<template>
  <v-layout class="caption header-row" align-center>
    <!-- The QMP id and the number of items -->
    <v-flex
      v-if="item.productId"
      class="grey--text text--darken-2 px-1 text-xs-center"
      :style="qmpStyle"
    >
      <span>{{ item.productId }}</span>
      <span v-if="qmp" class="pl-1">({{ qmp.items.length }})</span>
    </v-flex>
    <!-- A message to show if it does not have a QMP -->
    <v-flex v-else class="blue-grey--text font-italic text-xs-center">Sin QMP</v-flex>
    <!-- The options menu -->
    <v-item-card-options :item="item" />
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("matching");

import VItemCardOptions from "./ItemCardOptions";

export default {
  components: {
    VItemCardOptions
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(["similarItemsQmps"]),
    qmp() {
      return this.similarItemsQmps[this.item.productId];
    },
    qmpStyle() {
      return {
        borderRadius: "5px",
        backgroundColor: this.qmp ? this.qmp.color : ""
      };
    }
  }
};
</script>

<style scoped>
.header-row {
  margin-left: 28px;
}
</style>